const Constants = {
  SESSIONSTORAGE_PARTNERUSERS: 'partnerUsers',
  SESSIONSTORAGE_CURRENTPARTNERUSER: 'currentPartnerUser',
  SESSIONSTORAGE_PARTNERDETAIL: 'partnerDetail', //partnerDetail
  SESSIONSTORAGE_USERTYPE: 'userType',
};
export default Constants;
